import React from 'react';

import cs from 'classnames';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {StyledModalFooter} from 'app/components/general/TabbedModal';
import StateButton from 'app/general/widgets/StateButton';
import {gt} from 'app/utils/i18n';

type Props = {
  status: 'start' | 'success' | 'error';
  onClose: () => void;
  disabled: boolean;
  disabledTooltip: string;
  onSubmit: (e: React.MouseEvent) => void | Promise<unknown>;
  busyText?: string;
};

export function SignoffFooterPanel({
  status,
  onClose,
  disabled,
  disabledTooltip,
  onSubmit,
  busyText,
}: Props) {
  return (
    <StyledModalFooter>
      <button
        onClick={onClose}
        type="button"
        className="btn btn-link text-secondary"
      >
        <i className="fa fa-times mr-1" />
        {status === 'start' ? gt('Cancel') : gt('Close')}
      </button>
      {status === 'start' && (
        <LazyTooltip hide={!disabled} tooltip={disabledTooltip}>
          <StateButton
            className={cs('btn btn-primary', {disabled})}
            onClick={(e) => onSubmit(e as React.MouseEvent)}
            busyText={busyText ?? gt('Requesting Sign Off...')}
          >
            {gt('Request Sign Off')}
          </StateButton>
        </LazyTooltip>
      )}
    </StyledModalFooter>
  );
}
